import { forwardRef } from 'react';
import PropTypes from 'prop-types';

import Colors from '../utils/colors';

const LongTermLabelCircledIcon = forwardRef(
  ({ size = 40, className = '', ...props }, ref) => (
    <svg
      {...props}
      className={className}
      ref={ref}
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill={Colors.tertiary} />
      <mask
        id="mask0_1499_1338"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="7"
        y="7"
        width="26"
        height="26"
      >
        <rect x="7" y="7" width="26" height="26" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1499_1338)">
        <path
          d="M9.75 29.25V10.75H30.25V29.25H9.75Z"
          stroke="#0D0D0D"
          strokeWidth="1.5"
        />
        <path d="M15.5 8V13" stroke="#0D0D0D" strokeWidth="1.5" />
        <path d="M24.5 8V13" stroke="#0D0D0D" strokeWidth="1.5" />
        <path d="M9 16.5L31 16.5" stroke="#0D0D0D" strokeWidth="1.5" />
      </g>
    </svg>
  )
);

LongTermLabelCircledIcon.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string
};

export default LongTermLabelCircledIcon;
